// Meta Pixel ID
const PIXEL_ID = '934880919222021'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

// Initialize Meta Pixel and inject script
export function initMetaPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return // Already initialized

  const n = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;(n as any).callMethod(...args)
    } else {
      ;(n as any).queue.push(args)
    }
  } as unknown as typeof window.fbq

  if (!window._fbq) window._fbq = n
  window.fbq = n
  ;(n as any).push = n
  ;(n as any).loaded = true
  ;(n as any).version = '2.0'
  ;(n as any).queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
}

// Track PageView
export function trackPageView() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

// Track AddToCart
export function trackAddToCart() {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    value: 6.36,
    currency: 'USD',
    content_name: 'Protocolo 40+',
    content_type: 'product',
  })
}
